import type { GameSettings } from "../types";

interface SettingsScreenProps {
  settings: GameSettings;
  onChange: (settings: GameSettings) => void;
  onResetSave: () => void;
  onBack: () => void;
}

export function SettingsScreen({ settings, onChange, onResetSave, onBack }: SettingsScreenProps) {
  const update = <K extends keyof GameSettings>(key: K, value: GameSettings[K]) => onChange({ ...settings, [key]: value });
  return (
    <main className="settings-screen app-surface">
      <section className="settings-window">
        <header><div><div className="document-kicker">SYSTEM CONFIGURATION</div><h1>設定</h1></div><button type="button" onClick={onBack}>戻る</button></header>
        <div className="settings-group">
          <h2>音量</h2>
          <label><span>マスター音量</span><input type="range" min="0" max="1" step="0.05" value={settings.masterVolume} onChange={(e: { target: HTMLInputElement }) => update("masterVolume", Number(e.target.value))} /><output>{Math.round(settings.masterVolume * 100)}</output></label>
          <label><span>BGM音量</span><input type="range" min="0" max="1" step="0.05" value={settings.bgmVolume} onChange={(e: { target: HTMLInputElement }) => update("bgmVolume", Number(e.target.value))} /><output>{Math.round(settings.bgmVolume * 100)}</output></label>
          <label><span>効果音音量</span><input type="range" min="0" max="1" step="0.05" value={settings.sfxVolume} onChange={(e: { target: HTMLInputElement }) => update("sfxVolume", Number(e.target.value))} /><output>{Math.round(settings.sfxVolume * 100)}</output></label>
        </div>
        <div className="settings-group">
          <h2>表示</h2>
          <label><span>UIスケール</span><input type="range" min="0.85" max="1.25" step="0.05" value={settings.uiScale} onChange={(e: { target: HTMLInputElement }) => update("uiScale", Number(e.target.value))} /><output>{Math.round(settings.uiScale * 100)}%</output></label>
          <label><span>テキスト表示</span><select value={settings.textSpeed} onChange={(e: { target: HTMLSelectElement }) => update("textSpeed", e.target.value as GameSettings["textSpeed"])}><option value="instant">即時</option><option value="normal">標準</option><option value="slow">ゆっくり</option></select></label>
          <label className="check-row"><input type="checkbox" checked={settings.reducedFlash} onChange={(e: { target: HTMLInputElement }) => update("reducedFlash", e.target.checked)} /><span>点滅・瞬間変化を軽減する</span></label>
          <label className="check-row"><input type="checkbox" checked={settings.highContrast} onChange={(e: { target: HTMLInputElement }) => update("highContrast", e.target.checked)} /><span>高コントラスト表示</span></label>
        </div>
        <div className="settings-group danger-zone">
          <h2>データ管理</h2>
          <p>現在の進行、発見済み異変、エンディング記録を削除します。</p>
          <button type="button" className="danger-button" onClick={() => { if (window.confirm("すべてのセーブデータを削除しますか？")) onResetSave(); }}>セーブデータを初期化</button>
        </div>
        <div className="credits">企画・実装: 未読：0 開発プロジェクト / Version 0.1.0</div>
      </section>
    </main>
  );
}
